const nl = {
  tools_actions: {
    hotel_info: "Informatie over het hotel zoeken...",
    accommodation_info: "Informatie over het hotel zoeken...",
    accomodation_info: "Informatie over het hotel zoeken...",
    get_destination_info: "Zoeken wat u in de omgeving kunt doen...",
    get_guest_information: "Uw boeking controleren...",
    book_hotel_service_or_get_availability: "Beschikbaarheid van de service controleren...",
    list_accomodations: "Accommodaties laden...",
    set_accomodation: "Accommodatie laden...",
    list_accommodations: "Accommodaties laden...",
    set_accommodation: "Accommodatie laden...",
    destination_info: "Zoeken wat u in de omgeving kunt doen...",
    show_map: "Kaart voorbereiden...",
    consult_rules: "Huisregels raadplegen...",
    notify_reception: "Receptie informeren...",
    save_self_declared_stay: "Uw verblijf registreren...",
    generate_quote_for_single_room_longstay_rooms: "Een offerte voorbereiden...",
    generate_quote_for_multiple_rooms_longstay: "Een offerte voorbereiden...",
    hotel_info_iodah: "Perfect, ik zoek de informatie op en ben zo bij u...",
    generate_quote_for_rooms: "Een offerte voorbereiden...",
    check_availability: "Beschikbaarheid controleren...",
    print_calendar: "Agenda controleren...",
    nearby_restaurants: "Restaurants in de buurt zoeken...",
    nearby_attractions: "Attracties in de buurt zoeken...",
    human_handoff: "Verbinden met een medewerker...",
    tool_search_offers_by_request: "De beste aanbiedingen voor u zoeken...",
    tool_search_hotels_by_request: "De beste hotels voor u zoeken...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "Beschikbaarheid voor uw data controleren…",
      "Kamers en tarieven vergelijken…",
      "Offerte voorbereiden…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "Beschikbaarheid voor uw data controleren…",
      "Kamers en tarieven vergelijken…",
      "Offerte voorbereiden…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "Beschikbaarheid voor uw data controleren…",
      "Kamers en tarieven vergelijken…",
      "Offerte voorbereiden…",
    ],
    check_availability: [
      "Agenda controleren…",
      "Beschikbaarheid nagaan…",
      "Nog even geduld…",
    ],
    hotel_info: [
      "Informatie over het hotel raadplegen…",
      "Details ophalen…",
      "Antwoord voorbereiden…",
    ],
    accommodation_info: [
      "Informatie over het hotel raadplegen…",
      "Details ophalen…",
      "Antwoord voorbereiden…",
    ],
    accomodation_info: [
      "Informatie over het hotel raadplegen…",
      "Details ophalen…",
      "Antwoord voorbereiden…",
    ],
    get_destination_info: [
      "Omgeving verkennen…",
      "De beste tips verzamelen…",
      "Bijna klaar…",
    ],
    nearby_restaurants: [
      "Restaurants in de buurt zoeken…",
      "De beste keuzes selecteren…",
      "Bijna klaar…",
    ],
    nearby_attractions: [
      "Attracties in de omgeving zoeken…",
      "Het beste selecteren…",
      "Bijna klaar…",
    ],
    get_guest_information: [
      "Uw boeking ophalen…",
      "Verblijfdetails controleren…",
      "Nog even geduld…",
    ],
    book_hotel_service_or_get_availability: [
      "Beschikbaarheid van de service controleren…",
      "Tijden nagaan…",
      "Nog even geduld…",
    ],
    print_calendar: ["Agenda openen…", "Data controleren…"],
    list_accomodations: ["Accommodaties laden…", "Lijst voorbereiden…"],
    set_accomodation: ["Accommodatie openen…", "Informatie ophalen…"],
    list_accommodations: ["Accommodaties laden…", "Lijst voorbereiden…"],
    set_accommodation: ["Accommodatie openen…", "Informatie ophalen…"],
    destination_info: [
      "Omgeving verkennen…",
      "De beste tips verzamelen…",
      "Bijna klaar…",
    ],
    show_map: ["Locaties op de kaart zoeken…", "Route voorbereiden…"],
    consult_rules: ["Huisregels raadplegen…", "Voorwaarden controleren…"],
    notify_reception: ["Receptie informeren…", "Verzoek doorsturen…"],
    save_self_declared_stay: ["Uw verblijf registreren…", "Boeking koppelen…"],
    human_handoff: ["Receptie informeren…", "Gesprek doorgeven…"],
    tool_search_offers_by_request: [
      "De beste aanbiedingen voor u zoeken…",
      "Opties vergelijken…",
      "Bijna klaar…",
    ],
    tool_search_hotels_by_request: [
      "De meest geschikte hotels zoeken…",
      "Opties vergelijken…",
      "Bijna klaar…",
    ],
  },
  status_thinking: ["Een moment…", "Ik denk erover na…", "Nog even geduld…"],
  status_generic: ["Bijna klaar…", "Nog even geduld…"],
  tooltip_sentences: [
    "Wilt u snel een offerte? 😊",
    "Wilt u informatie over het hotel? 😊",
  ],
  tooltip_sentences_iodah: [
    "Welkom bij The First Hotels.",
    "Hoe kan ik u vandaag helpen?",
  ],
  welcome_message_default:
    "Hallo! 👋 Ik ben de virtuele assistent van het hotel. Ik kan beschikbaarheid en prijzen controleren en al uw vragen over uw verblijf beantwoorden. Hoe kan ik u helpen?",
  teaser_pill_fixed: "Offerte in 30 seconden ⚡",
  teaser_pills_rotating: [
    "Is er beschikbaarheid voor mijn data? 📅",
    "Welke kamers hebben jullie? 🛏️",
    "Hoe is het ontbijt? 🥐",
  ],
  quote_pills: {
    alone: "Ik ben alleen",
    alone_message: "Ik ben alleen, één persoon",
    party: "We zijn met {n}",
    party_message: "We zijn met {n} personen",
  },
  replies_in_realtime: "Antwoorden in realtime",
  ai_disclosure: "Ik ben de AI-assistent van de accommodatie. U kunt om medewerkers vragen wanneer u wilt.",
  assistant_default_name: "Naam assistent",
  powered_by: "Mogelijk gemaakt door",
  type_a_message: "Schrijf een bericht...",
  speak_with_operator: "Spreek met een medewerker",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Bel ons",
    subtitle: "Onze spraakassistent neemt direct op",
    badge: "Nieuw",
    call: "Bellen",
    copy: "Nummer kopiëren",
    copied: "Nummer gekopieerd",
  },
  voice_panel: {
    status_idle: "Klaar",
    status_connecting: "Spraak voorbereiden...",
    status_listening: "Luisteren",
    status_error: "Verbindingsfout",
    status_warming: "Spraak opstarten...",
    transcript_empty: "Zeg iets…",
    end_call: "Gesprek beëindigen",
    start_call: "Spraakgesprek starten",
    start_mode: "Spraakmodus inschakelen",
    stop_mode: "Spraakmodus stoppen",
  },
  continue_on_whatsapp: "Verder op WhatsApp",
  whatsapp_handoff_prefill:
    "Hallo! Ik was aan het chatten met de assistent op de website en wil hier graag verder.",
  request_quote: "Offerte aanvragen",
  map_directions: "Openen in Maps",
  handoff_form: {
    title: "Neem contact op",
    desc: "Laat ons uw gegevens achter, dan neemt ons team zo snel mogelijk contact met u op.",
    firstname: "Voornaam",
    lastname: "Achternaam",
    email: "E-mail",
    phone: "Telefoon",
    phone_hint: "We gebruiken dit om contact met u op te nemen, ook via WhatsApp.",
    phone_search: "Land zoeken",
    submit: "Verzoek versturen",
    success:
      "Dank u wel! We hebben uw gegevens ontvangen en nemen zo snel mogelijk contact met u op. 😊",
    handoff_email_success:
      "We antwoorden u per e-mail op {email}. U kunt deze pagina sluiten.",
    submit_error: "Er ging iets mis. Probeer het straks opnieuw.",
    firstname_error: "Vul uw voornaam in.",
    lastname_error: "Vul uw achternaam in.",
    email_error: "Vul een geldig e-mailadres in.",
    phone_error: "Vul een geldig telefoonnummer in.",
    close_aria_label: "Sluiten",
  },
  error_generic: "Er ging iets mis. Probeer het later opnieuw.",
  delete_chat_aria_label: "Gesprek verwijderen",
  close_aria_label: "Gesprek sluiten",
  send_aria_label: "Bericht versturen",
  chat_widget_aria_label: "Chatwidget",
  previous_aria_label: "Vorige",
  next_aria_label: "Volgende",
  attachment_alt: "Bijlage",
  assistant_icon_alt: "Pictogram van de assistent",
  bot_avatar_alt: "Avatar van de assistent",
  video_label: "Video {n}",
  open_content: "Inhoud openen",
  book_now: "Boek nu",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "E-mail sturen",
  call_now: "Bellen",
  whatsapp_chat: "Stuur ons een bericht op WhatsApp",
  open_link: "Link openen",
  discover_hotel: "Ontdek het hotel",
  discover_offer: "Ontdek de aanbieding",
  quick_quote: "Vraag een offerte aan",
  view_hotel_photos: "Bekijk de foto's van het hotel",
  view_photos: "Bekijk de foto's",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Restaurant",
  animation_gallery: "Animatie",
  rooms_gallery: "Kamers",
  look_hotel_galleries: "Bekijk de andere galerijen van het hotel:",
  back_to_chat: "Terug naar de chat",
  carousel_open: "Openen",
  carousel_close: "Sluiten",
  available: "Beschikbaar",
  expand_view: "Meeslepende weergave",
  read_more: "Lees meer",
  explore: "Verkennen",
  photo: "Foto",
  from_price: "vanaf",
  rates: "Tarieven",
  quote_group: {
    title: "Uw offerte",
    total: "Totaal",
    room: "Kamer {n}",
    other_options: "Andere opties",
    rooms: "{n} kamers",
    adult: "volwassene",
    adults: "volwassenen",
    child: "kind",
    children: "kinderen",
  },
  anchor_rooms: "Onze voorstellen",
  anchor_discover: "Te ontdekken",
  anchor_places: "Locatie en omgeving",
  anchor_videos: "Video's",
  videos: "video's",
  watch_video: "Bekijk de video",
  feedback_useful: "Nuttig antwoord",
  feedback_not_useful: "Niet nuttig",
  proposal: "voorstel",
  proposals: "voorstellen",
  contents: "inhoud",
  places: "plekken",
  explore_title: "Uw verblijf",
  explore_rooms: "Kamers en tarieven",
  explore_discover: "Te ontdekken",
  explore_videos: "Video's",
  explore_places: "Plekken",
  directions: "Routebeschrijving",
  minimize_view: "Verkleinen",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "Uw route",
  itinerary: "Route",
  stops: "haltes",
  stop: "halte",
  walk_min: "min lopen",
  itinerary_start: "Startpunt",
  your_hotel: "Uw hotel",
  explore_itineraries: "Routes",
  map_loading: "Kaart laden…",
  cat_restaurant: "Eten en drinken",
  cat_attraction: "Attracties",
  cat_beach: "Stranden",
  cat_essential: "Handige diensten",
  cat_event: "Evenementen",
  cat_place: "Plek",
  reviews: "beoordelingen",

  // Boekingsflow in de widget. In v0.5 draait dit tegen de testdriver:
  // er wordt nergens iets gereserveerd, en dat is precies wat mock_notice
  // hardop moet zeggen.
  booking: {
    choose_rate: "Kies het tarief",
    your_details: "Uw gegevens",
    review: "Overzicht",
    notes: "Opmerkingen of verzoeken",
    notes_placeholder: "Allergieën, aankomsttijd, wieg…",
    privacy: "Ik heb het privacybeleid gelezen en ga ermee akkoord.",
    marketing: "Ik wil aanbiedingen en nieuws van het hotel ontvangen.",
    privacy_required: "U moet akkoord gaan met het privacybeleid om door te gaan.",
    continue: "Doorgaan",
    back: "Terug",
    confirm: "Boeking bevestigen",
    submitting: "Een moment…",
    cancel: "Annuleren",
    close: "Sluiten",
    retry: "Opnieuw proberen",
    total: "Totaal",
    cheapest: "Voordeligst",
    per_night: "per nacht",
    no_payment_now: "Nu niets betalen",
    nights: "nachten",
    guests: "gasten",
    reference: "Referentie",
    success_title: "Boeking bevestigd",
    success_body: "U ontvangt binnenkort de bevestiging per e-mail.",
    error_title: "Dit is niet gelukt",
    error_body:
      "We konden de boeking niet afronden. Probeer het straks opnieuw.",
    mock_notice: "Testmodus: er is geen echte boeking aangemaakt.",
  },
};

export default nl;
